import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradesService } from '@/services/trades/trades-service';
import { tradesKeys } from '@/services/query-keys/trades-keys';

export const useSetSettlementDate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, actualSettlementDate, reason }: { id: number; actualSettlementDate: string; reason?: string }) =>
      tradesService.setSettlementDate(id, actualSettlementDate, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tradesKeys.all });
    },
  });
};
